import React from "react";

export default function IconHybrid(props) {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_8234_42784)">
        <path
          d="M3.33327 13.7383H1.66673C1.44594 13.7376 1.23438 13.6502 1.07825 13.4952C0.92213 13.3401 0.834128 13.13 0.833468 12.9107V10.0141C0.612675 10.0135 0.401114 9.92609 0.244989 9.77103C0.0888637 9.61597 0.000861663 9.40585 0.000202247 9.18656V6.7038C-0.00279218 6.53996 0.0274916 6.3772 0.0892448 6.22525C0.150998 6.07329 0.242954 5.93526 0.359619 5.81939C0.476285 5.70352 0.615268 5.61219 0.768266 5.55086C0.921263 5.48952 1.08514 5.45945 1.2501 5.46242H3.7499C3.91486 5.45945 4.07874 5.48952 4.23173 5.55086C4.38473 5.61219 4.52371 5.70352 4.64038 5.81939C4.75705 5.93526 4.849 6.07329 4.91076 6.22525C4.97251 6.3772 5.00279 6.53996 4.9998 6.7038V9.18656C4.99914 9.40585 4.91114 9.61597 4.75501 9.77103C4.59889 9.92609 4.38732 10.0135 4.16653 10.0141V12.9107C4.16587 13.13 4.07787 13.3401 3.92175 13.4952C3.76562 13.6502 3.55406 13.7376 3.33327 13.7383ZM2.5 5.04863C2.17039 5.04863 1.84818 4.95155 1.57412 4.76968C1.30006 4.58781 1.08646 4.3293 0.960325 4.02686C0.83419 3.72442 0.801187 3.39162 0.86549 3.07055C0.929794 2.74947 1.08852 2.45455 1.32158 2.22307C1.55465 1.99159 1.8516 1.83395 2.17488 1.77009C2.49815 1.70622 2.83324 1.739 3.13775 1.86427C3.44227 1.98955 3.70255 2.2017 3.88567 2.47389C4.06879 2.74608 4.16653 3.06609 4.16653 3.39345C4.16543 3.8321 3.9895 4.25246 3.6772 4.56263C3.3649 4.8728 2.94165 5.04753 2.5 5.04863Z"
          fill="white"
        />
        <g clip-path="url(#clip1_8234_42784)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9 12.7383C9.65661 12.7383 10.3068 12.609 10.9134 12.3577C11.52 12.1064 12.0712 11.7381 12.5355 11.2738C12.9998 10.8095 13.3681 10.2583 13.6194 9.6517C13.8707 9.04507 14 8.39489 14 7.73828C14 7.08167 13.8707 6.43149 13.6194 5.82486C13.3681 5.21824 12.9998 4.66704 12.5355 4.20275C12.0712 3.73845 11.52 3.37016 10.9134 3.11888C10.3068 2.86761 9.65661 2.73828 9 2.73828C7.67392 2.73828 6.40215 3.26507 5.46447 4.20275C4.52678 5.14043 4 6.4122 4 7.73828C4 9.06436 4.52678 10.3361 5.46447 11.2738C6.40215 12.2115 7.67392 12.7383 9 12.7383ZM8.32389 5.5105L11.4594 7.25273C11.546 7.30085 11.6181 7.37125 11.6683 7.45662C11.7186 7.54199 11.745 7.63924 11.745 7.73828C11.745 7.83733 11.7186 7.93457 11.6683 8.01994C11.6181 8.10531 11.546 8.17571 11.4594 8.22384L8.32389 9.96606C8.22236 10.0225 8.10785 10.0514 7.9917 10.05C7.87555 10.0485 7.7618 10.0168 7.6617 9.95782C7.56161 9.89887 7.47866 9.8148 7.42106 9.71393C7.36346 9.61305 7.33322 9.49888 7.33333 9.38273V6.09384C7.33322 5.97768 7.36346 5.86351 7.42106 5.76264C7.47866 5.66176 7.56161 5.57769 7.6617 5.51875C7.7618 5.4598 7.87555 5.42804 7.9917 5.42659C8.10785 5.42514 8.22236 5.45407 8.32389 5.5105Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_8234_42784">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.738281)"
          />
        </clipPath>
        <clipPath id="clip1_8234_42784">
          <rect
            width="8"
            height="10"
            fill="white"
            transform="translate(6 2.73828)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
